import {
  Box,
  Button,
  Center,
  Heading,
  Input,
  Link,
  Text
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { useLogin } from 'hooks/auth';
import { APP_DASHBOARD, REGISTER } from 'lib/routes';
import { emailValidate, passwordValidate } from 'utils/forms-validate';

import { Field } from '../../components/ui/field';

export default function Login(props) {
  const { login, isLoading } = useLogin();
  const { register, handleSubmit, reset, formState } = useForm();

  async function handleLogin(data) {
    const succeeded = await login({
      email: data.email,
      password: data.password,
      redirectTo: APP_DASHBOARD
    });

    if (succeeded) reset();
  }

  return (
    <Center w="100%" h="100vh">
      <Box mx="1" maxW="md" p="9" borderWidth="1px" borderRadius="lg">
        <Heading mb="4" size="lg" textAlign="center">
          Log In
        </Heading>

        <form onSubmit={handleSubmit(handleLogin)}>
          <Field
            errorText={formState.errors.email?.message}
            py="2"
            label="Email"
          >
            <Input
              type="email"
              placeholder="user@email.com"
              {...register('email', emailValidate)}
            />
          </Field>
          <Field
            errorText={formState.errors.password?.message}
            py="2"
            label="Password"
          >
            <Input
              type="password"
              placeholder="abcd1234"
              {...register('password', passwordValidate)}
            />
          </Field>

          <Button
            mt="4"
            type="submit"
            colorPalette="themeColor"
            size="md"
            width="full"
            isLoading={isLoading}
            loadingText="Logging In"
          >
            Log In
          </Button>
        </form>

        <Text fontSize="xlg" align="center" mt="6">
          Don't have an account?{' '}
          <Link
            as={RouterLink}
            to={REGISTER}
            color="themeColor"
            fontWeight="medium"
            textDecor="underline"
            _hover={{ background: 'themeColor' }}
          >
            Register
          </Link>{' '}
          instead!
        </Text>
      </Box>
    </Center>
  );
}
